import mod from "-!./limit-tab.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./limit-tab.js?vue&type=script&lang=js&external"